/* eslint-disable max-lines */
import MontserratTtf from '../../../../fonts/Montserrat-Regular.ttf';
import MontserratEot from '../../../../fonts/Montserrat-Regular.eot';
import MontserratWoff from '../../../../fonts/Montserrat-Regular.woff';
import MontserratBlackTtf from '../../../../fonts/Montserrat-Black.ttf';
import MontserratBlackEot from '../../../../fonts/Montserrat-Black.eot';
import MontserratBlackWoff from '../../../../fonts/Montserrat-Black.woff';
import RobotoCondensedTtf from '../../../../fonts/Roboto-condensed.ttf';
import RobotoCondensedEot from '../../../../fonts/Roboto-condensed.eot';
import RobotoCondensedWoff from '../../../../fonts/Roboto-condensed.woff';
import baseMuiTheme from '../../base-mui-theme';
import brandConstants from '../../brand-constants';
const { fontSizes, colors } = brandConstants;
const miniMyAccountBrandTheme = {
    ...baseMuiTheme,
    breakpoints: {
        values: brandConstants.screens,
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                '@global': {
                    '@font-face': [
                        {
                            fontFamily: 'Montserrat',
                            src: `
              url(${MontserratTtf}) format('ttf'),
              url(${MontserratEot}) format('eot'),
              url(${MontserratWoff}) format('woff'),
              url(${MontserratWoff}) format('woff2')`,
                            fontWeight: 'normal',
                            fontStyle: 'normal',
                        },
                        {
                            fontFamily: 'Montserrat-Black',
                            src: `
              url(${MontserratBlackTtf}) format('ttf'),
              url(${MontserratBlackEot}) format('eot'),
              url(${MontserratBlackWoff}) format('woff'),
              url(${MontserratBlackWoff}) format('woff2')`,
                            fontWeight: 'normal',
                            fontStyle: 'normal',
                        },
                        {
                            fontFamily: 'Roboto-Condensed',
                            src: `
              url(${RobotoCondensedTtf}) format('ttf'),
              url(${RobotoCondensedEot}) format('eot'),
              url(${RobotoCondensedWoff}) format('woff'),
              url(${RobotoCondensedWoff}) format('woff2')`,
                            fontWeight: 'normal',
                            fontStyle: 'normal',
                        },
                    ],
                },
            },
        },
        MuiButtonBase: {
            styleOverrides: {
                root: {
                    fontSize: fontSizes.sm,
                },
            },
        },
        MuiBreadcrumbs: {
            styleOverrides: {
                ol: {
                    alignItems: 'baseline',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    fontSize: fontSizes.sm,
                },
                contained: {
                    fontSize: fontSizes.sm,
                },
            },
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    fontSize: fontSizes.lg,
                },
                fontSizeLarge: {
                    fontSize: fontSizes.xxl,
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    height: 51,
                    borderColor: colors.light_grey,
                    '&:hover': {
                        borderColor: colors.third,
                    },
                    '& .Mui-focused': {
                        borderColor: colors.third,
                    },
                    '& fieldset': {
                        border: '2px solid',
                        borderColor: 'inherit',
                    },
                },
            },
        },
        MuiFormControlLabel: {
            styleOverrides: {
                root: {
                    '& a': {
                        color: colors.primary,
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    padding: 0,
                    maxHeight: 51,
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: 0,
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                },
            },
        },
        MyAccount_Signup: {
            styleOverrides: {
                cardContent: {
                    padding: 0,
                },
            },
        },
        MyAccount_Signup_Header: {
            styleOverrides: {
                root: {
                    padding: 0,
                },
                title: {
                    display: 'none',
                },
            },
        },
        Signup_ButtonSubmit: {
            styleOverrides: {
                submitButtonContainer: {
                    float: 'unset',
                    margin: 0,
                },
                submitButton: {
                    width: '100%',
                    maxWidth: 'unset',
                },
            },
        },
        Signup_MiniWidgetButtonSubmit: {
            styleOverrides: {
                submitButton: {
                    maxHeight: 40,
                },
            },
        },
        MyAccount_GenericInput: {
            styleOverrides: {
                root: {
                    marginRight: 0,
                    borderColor: colors.light_grey,
                    '&:hover': {
                        borderColor: colors.third,
                    },
                    '&.Mui-focused': {
                        borderColor: colors.third,
                    },
                    '& fieldset': {
                        border: '2px solid',
                        borderColor: 'inherit',
                    },
                },
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                asterisk: {
                    color: colors.primary,
                },
            },
        },
        Login_Form: {
            styleOverrides: {
                submitButton: {
                    borderRadius: 4,
                },
            },
        },
        MyAccount_DisclaimerCheckbox: {
            styleOverrides: {
                label: {
                    display: 'none',
                },
            },
        },
        MyAccount_TabContainer: {
            styleOverrides: {
                tabs: {
                    marginBottom: 20,
                },
            },
        },
        MyAccount_MiniWidgetButton: {
            styleOverrides: {
                root: {
                    color: colors.white,
                    background: colors.primary,
                    padding: '6px 0',
                    width: 300,
                },
                welcomeMessage: {
                    paddingRight: '5px',
                    color: colors.third,
                },
            },
        },
        MyAccount_PasswordWidget: {
            styleOverrides: {
                eyeIconButton: {
                    marginRight: 5,
                },
            },
        },
        MyAccount_Login: {
            styleOverrides: {
                container: {
                    paddingBottom: '40px',
                },
                loginModule: {
                    boxShadow: 'rgb(0 0 50 / 20%) 0px 2px 5px',
                },
            },
        },
        MyAccount_MiniWidgetModal: {
            styleOverrides: {
                modalRoot: {
                    [`@media (max-width:${brandConstants.screens.sm}px)`]: {
                        width: 'calc(100vw - 80px)',
                        height: ' calc(100vh - 160px)',
                        maxHeight: '500px;',
                    },
                },
                closeButton: {
                    width: '100px',
                    height: '38px',
                },
                icon: {
                    height: '38px',
                },
            },
        },
    },
};
export default miniMyAccountBrandTheme;
//# sourceMappingURL=mini-my-account-brand-theme.js.map